import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { EntryOptions, PropertyDefinition, PropertyMappingType, } from "app/library/layout-builder";
import { MobileInstrumentsProps } from "./types";
import { MetaTypeEnum } from "app/shared";

export class MobileInstrumentsDefinitions extends CmsReactComponent<MobileInstrumentsProps> {
    static defaultProps = {};

    static schemaName = "mobile-instruments";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "title",
            mapping: {
                type: PropertyMappingType.String,
            },
            default: "",
            text: "Başlık",
        },
        {
            name: "secondTitle",
            mapping: {
                type: PropertyMappingType.String,
            },
            default: "",
            text: "Alt Başlık",
        },
        {
            name: "backAnchor",
            mapping: {
                type: PropertyMappingType.LinkWizard,
            },
            default: "",
            text: "Geriye Dönmek İçin Kullanılan Anchor",
        },
        {
            name: "audio",
            mapping: {
                type: PropertyMappingType.File
            },
            text: "Ses"
        }
    ];

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [
                MetaTypeEnum.Text,
                MetaTypeEnum.TextArea,
                MetaTypeEnum.SingleImage,
                MetaTypeEnum.PhotoGallery,
                MetaTypeEnum.Editor,
                MetaTypeEnum.Link,
                MetaTypeEnum.File
            ],
        },
    };
}
